module.exports = __webpack_public_path__ + "static/media/22ESCWA11.82b175be.jpg";